export const ContentSliderData = [
  {
    id: 1,
    src: '/images/1969.JPG',
    alt: 'slider-img',
  },
  {
    id: 2,
    src: '/images/도버.jpg',
    alt: 'slider-img',
  },
  {
    id: 3,
    src: '/images/드로잉.JPG',
    alt: 'slider-img',
  },
  {
    id: 4,
    src: '/images/도쿄.JPG',
    alt: 'slider-img',
  },
  {
    id: 5,
    src: '/images/코코볼.JPG',
    alt: 'slider-img',
  },
  {
    id: 6,
    src: '/images/행성.jpg',
    alt: 'slider-img',
  },
  {
    id: 7,
    src: '/images/신밧드의 모험.jpg',
    alt: 'slider-img',
  },
  {
    id: 8,
    src: '/images/마르세유.jpg',
    alt: 'slider-img',
  },
  {
    id: 9,
    src: '/images/나.JPG',
    alt: 'slider-img',
  },
  {
    id: 10,
    src: '/images/신밧드의 모험2.jpg',
    alt: 'slider-img',
  },
  {
    id: 11,
    src: '/images/런던2.jpg',
    alt: 'slider-img',
  },
  {
    id: 12,
    src: '/images/니부.JPG',
    alt: 'slider-img',
  },
  {
    id: 13,
    src: '/images/자이로드롭.jpg',
    alt: 'slider-img',
  },
  {
    id: 14,
    src: '/images/런던3.jpg',
    alt: 'slider-img',
  },
];
